<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 1H13C13.5523 1 14 1.44772 14 2V6.5C14 6.77614 14.2239 7 14.5 7C14.7761 7 15 6.77614 15 6.5V2C15 0.895431 14.1046 0 13 0H3C1.89543 0 1 0.895431 1 2V14C1 15.1046 1.89543 16 3 16H6.5C6.77614 16 7 15.7761 7 15.5C7 15.2239 6.77614 15 6.5 15H3C2.44772 15 2 14.5523 2 14V2C2 1.44772 2.44772 1 3 1Z" />
    <path
      d="M4.5 3.5C4.22386 3.5 4 3.72386 4 4C4 4.27614 4.22386 4.5 4.5 4.5H11.5C11.7761 4.5 12 4.27614 12 4C12 3.72386 11.7761 3.5 11.5 3.5H4.5Z" />
    <path
      d="M4 7C4 6.72386 4.22386 6.5 4.5 6.5H8.5C8.77614 6.5 9 6.72386 9 7C9 7.27614 8.77614 7.5 8.5 7.5H4.5C4.22386 7.5 4 7.27614 4 7Z" />
    <path
      d="M4 10C4 9.72386 4.22386 9.5 4.5 9.5H6.5C6.77614 9.5 7 9.72386 7 10C7 10.2761 6.77614 10.5 6.5 10.5H4.5C4.22386 10.5 4 10.2761 4 10Z" />
    <circle cx="12" cy="12" r="3.5" />
    <path d="M12 10.2856V11.9999" stroke-linecap="round" />
    <path d="M12 12L13.1429 13.1429" stroke-linecap="round" />
  </svg>
</template>

<script setup lang="ts">
defineOptions({
  name: 'online-order'
})
</script>
